import { useCallback as a } from "react";
import { useTealiumDataLayer as i } from "../external/@nextgen-web-framework/all/dist/es/components/Tealium/TealiumScript.js";
import { AccountType as t } from "../external/@nextgen-web-framework/all/dist/es/components/Session/types/propsType.js";
import { Logger as u } from "@nextgen-web-framework/core";
import { ProfileEventsEnum as r } from "../types/enums/profileEnums.js";
import { ProfileEvents as n } from "./profileEventsUtil.js";
const m = u.getInstance();
function v() {
  const o = i();
  return a(
    (s) => {
      let e = "";
      switch (s) {
        case t.BusinessOwner:
          e = r.AboRegistrationComplete;
          break;
        case t.Member:
          e = r.MemberRegistrationComplete;
          break;
        case t.Customer:
          e = r.CustomerRegistrationComplete;
          break;
        default:
          e = "";
      }
      m.log(e, "e"), e && n.publishEvent({ event: e });
    },
    [o]
  );
}
function E() {
  const o = i();
  return a(
    (s) => {
      let e = "";
      switch (s) {
        case t.BusinessOwner:
          e = r.AboRegistrationStart;
          break;
        case t.Member:
          e = r.MemberRegistrationStart;
          break;
        case t.Customer:
          e = r.CustomerRegistrationStart;
          break;
        default:
          e = "";
      }
      m.log(e, "e"), e && n.publishEvent({ event: e });
    },
    [o]
  );
}
export {
  v as useRegistrationCompletionEvent,
  E as useRegistrationStartEvent
};
//# sourceMappingURL=registrationCompletionEventUtil.js.map
